module.exports = __webpack_public_path__ + "img/qr.cd064f54.png";